export enum EPlacementType {
  ShoppingMall = 1,
  StreetRetail = 2,
}
